export const SESSION_SECRET = process.env.NEXTAUTH_SECRET;
export const JWT_SECRET = process.env.NEXTAUTH_JWT_SECRET;

export const REFRESH_TOKEN_TOLERANCE_TIME = 1000 * 60 * 60; // 60 minutes
